































































































import * as _ from 'lodash'
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'
import { ApiGeneralObjectArrayPayload, ApiPayloadValueType } from '@/tcw/api/types'
import { InvalidFields } from '@/components/common/form/types'

@Component
export default class KoutsuhiKeiroCard extends Mixins(BaseComponent) {
  @Prop({ default: () => [] })
  protected keiroList!: ApiGeneralObjectArrayPayload
  @Prop({ type: Boolean, default: false })
  protected disabled!: boolean
  @Prop({
    default: () => {
      /** */
    }
  })
  protected serverCheckInfo!: InvalidFields

  protected tmpKeiroList: ApiGeneralObjectArrayPayload = []

  protected get keiroListView(): ApiGeneralObjectArrayPayload {
    if (Array.isArray(this.keiroList) && this.keiroList.length > 1) {
      return this.keiroList
    } else {
      return []
    }
  }

  protected set keiroListView(keiroList: ApiGeneralObjectArrayPayload) {
    this.updateKeiroList(keiroList)
  }

  @Emit('update:keiroList')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected updateKeiroList(keiroList: ApiGeneralObjectArrayPayload): void {
    keiroList.forEach((keiro, idx) => {
      keiro.bango = idx + 1
    })
  }

  protected changeValue(idx: number, value: ApiPayloadValueType): void {
    const tmpKeiroList = _.cloneDeep(this.keiroListView)
    tmpKeiroList[idx].eki = value
    this.updateKeiroList(tmpKeiroList)
  }
  protected addRoute(idx: number): void {
    const emptyRow = {
      bango: idx + 1,
      eki: '',
      keiro: '',
      kingaku: 0,
      biko: ''
    }
    const tmpKeiroList = _.cloneDeep(this.keiroListView)
    tmpKeiroList.splice(idx, 0, emptyRow)
    this.updateKeiroList(tmpKeiroList)
  }
  protected deleteRoute(idx: number): void {
    const tmpKeiroList = _.cloneDeep(this.keiroListView)
    tmpKeiroList.splice(idx, 1)
    this.updateKeiroList(tmpKeiroList)
  }
}
